import { SectionLayout } from './types';

export const layoutVariants = {
  default: 'container-margin-narrow',
  wide: 'container-margin-wide',
  sidebar: 'container-margin-wide gap-x-3 gap-y-8 flex flex-col lg:flex-row',
  inherit: '',
} satisfies Record<SectionLayout, string>;
